import React, { FormEvent } from 'react';
import Button from './button';
import SortDownIcon from '@rsuite/icons/SortDown';
import SortUpIcon from '@rsuite/icons/SortUp';
import SortIcon from '@rsuite/icons/Sort';

interface Props {
  id: string;
  order?: boolean | undefined | null;
  onClick: (e: FormEvent<Element>) => void;
}

const SortButton = ({ id, order, onClick }: Props) => {
  const handleClick = (e: FormEvent<Element>) => {
    e.preventDefault();
    onClick(e);
  };

  return (
    <Button id={id} onclick={handleClick}>
      {order === true ? (
        <SortDownIcon height={18} width={18} />
      ) : order === false ? (
        <SortUpIcon height={18} width={18} />
      ) : (
        <SortIcon height={22} width={18} />
      )}
    </Button>
  );
};

export default SortButton;
